import { useEffect, useState } from "react";
import AllTimeFavouritesSection from "../Components/AllTimeFavouritesSection/AllTimeFavouritesSection";
import BestSellerSection from "../Components/BestSellerSection/BestSellerSection";
import BlogsSection from "../Components/BlogsSection/BlogsSection";
import CategorySection from "../Components/CategorySection/CategorySection";
import FooterPolicySection from "../Components/FooterPolicySection/FooterPolicySection";
import GiftGridSection from "../Components/GiftGridSection/GiftGridSection";
import HomeBanner from "../Components/HomeBanner/HomeBanner";
import HomeOfferBanners from "../Components/HomeOfferBanners/HomeOfferBanners";
import ParallaxSection from "../Components/ParallaxSection/ParallaxSection";
import ServicesSection from "../Components/ServicesSection/ServicesSection";
import TestimonialWithParallaxSection from "../Components/TestimonialWithParallaxSection/TestimonialWithParallaxSection";
import VideoSection from "../Components/VideoSection/VideoSection";
import GetApiCall from "../Helper/GetApi";
import PostApiCall from "../Helper/PostApi";
import GetSeoData from "../Helper/GetSeoData";
import OccasionSection from "../Components/CategorySection/OccasionSection";
import GiftSwiperSection from "../Components/GiftGridSection/GiftSwiperSection";
import WomensDaySection from "../Components/WomensDaySection/WomensDaySection";
import HomeContent from "../Components/HomeContent/HomeContent";
import ValentineSection from "../Components/ValentinesSection/ValentineSection";

export default function Home() {
  const [mainBanner, setMainBanner] = useState([]);
  const [bestSeller, setBestSeller] = useState([]);
  const [bannerData, setBannerData] = useState([]);
  const [parallax1Banner, setParallax1Banner] = useState([]);
  const [parallax2Banner, setParallax2Banner] = useState([]);
  const [blogData, setBlogData] = useState([]);
  const [mainOfferBanners, setMainOfferBanners] = useState([]);
  const [websiteTestimonialData, setWebsiteTestimonialData] = useState([]);
  const [featuredProductCategories, setFeaturedProductCategories] = useState(
    []
  );
  const [heading1, setHeading1] = useState([]);
  const [heading2, setHeading2] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    getBanners();
    GetBlogArticle();
    GetTestimonial();
    GetFeaturedProductCategories();
    GetApiCall.getRequest("GetHomepageSetup").then((resultdes) =>
      resultdes.json().then((obj) => {
        // setHomePageSetup(obj.data);
        obj.data
          .filter((value) => value.fld_section_name === "Featured Products")
          .forEach((filtereddata) => {
            PostApiCall.postRequest(
              {
                sectionname: filtereddata.fld_section_name,
                itemchoice: filtereddata.fld_item_choice,
              },
              "GetWebsiteHomePageItems"
            ).then((results) => {
              if (results.status === 200 || results.status === 201) {
                results.json().then((data) => {
                  setHeading1(filtereddata.fld_headline1);
                  setHeading2(filtereddata.fld_headline2);
                  setBestSeller(data.data);
                });
              }
            });
          });
        obj.data
          .filter((value) => value.fld_section_name === "Exclusive Offers")
          .forEach((filtereddata) => {
            PostApiCall.postRequest(
              {
                sectionname: filtereddata.fld_section_name,
                itemchoice: filtereddata.fld_item_choice,
              },
              "GetWebsiteHomePageItems"
            ).then((results) => {
              results.json()?.then((obj) => {
                if (results.status === 200 || results.status === 201) {
                  // setExclusiveOffers(obj.data);
                }
              });
            });
          });
      })
    );
  }, []);
  const GetTestimonial = () => {
    PostApiCall.postRequest(
      {
        whereClause: "",
        recordCount: "*",
      },
      "GetTestimonial"
    ).then((results) => {
      results.json()?.then((obj) => {
        if (results.status === 200 || results.status === 201) {
          setWebsiteTestimonialData(obj.data);
        }
      });
    });
  };
  const GetBlogArticle = () => {
    GetApiCall.getRequest("GetBlogArticle").then((homepagesetupresult) => {
      homepagesetupresult.json().then((obj) => {
        setBlogData(obj.data);
      });
    });
  };
  const getBanners = () => {
    GetApiCall.getRequest("GetBannersV1").then((results) =>
      results.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          setBannerData(obj1.data);
          setIsLoading(true);
          var filterBanner = obj1.data.filter(
            (item) => item.location === "Main"
          );
          var mainOffer = obj1.data.filter(
            (item) => item.location === "MainBottom"
          );
          var Parallax1Banner = obj1.data.filter(
            (item) => item.location === "Parallax"
          );
          var Parallax2Banner = obj1.data.filter(
            (item) => item.location === "Parallax2"
          );
          // var RightMainBanner = obj1.data.filter(
          //   (item) => item.location === "MainRight"
          // );
          // var CatBanner = obj1.data.filter(
          //   (item) => item.location === "CategoryBanner"
          // );
          setMainOfferBanners(mainOffer);
          setMainBanner(filterBanner);
          setParallax1Banner(Parallax1Banner);
          setParallax2Banner(Parallax2Banner);
          // setMainRightBanner(RightMainBanner)
          // setCategoryBanner(CatBanner)
        }
      })
    );
  };
  const GetFeaturedProductCategories = () => {
    PostApiCall.postRequest({}, "GetFeaturedProductCategories").then(
      (results) =>
        results.json().then((obj1) => {
          if (results.status === 200 || results.status === 201) {
            setFeaturedProductCategories(obj1?.data);
          }
        })
    );
  };
  return (
    <>
      <GetSeoData type="Home" id={null} />

      <HomeBanner banners={mainBanner} />
      {/* <HomeOfferBanners banners={mainOfferBanners} /> */}
      {/* <CategorySection /> */}
      {/* <HomeOfferBanners banners={mainOfferBanners} /> */}
      {/* <CategorySection /> */}
      <OccasionSection />
      {/* <WomensDaySection
        itemsData={bestSeller}
        heading1={heading1}
        heading2={heading2}
      /> */}
      {/* <ValentineSection
        itemsData={bestSeller}
      /> */}
      <BestSellerSection
        itemsData={bestSeller}
        heading1={heading1}
        heading2={heading2}
      />
      {/* <AllCategorySection /> */}
      {/* <ExclusiveOffersSection itemsData={exclusiveOffers} /> */}
      {/* <ParallaxSection parallaxData={parallax1Banner} height="40vh" /> */}
      {featuredProductCategories?.slice(0, 2).map((item) => (
        <AllTimeFavouritesSection itemsData={item} />
      ))}
      <ParallaxSection parallaxData={parallax2Banner} height="30vh" />
      {featuredProductCategories?.slice(2, 4).map((item) => (
        <AllTimeFavouritesSection itemsData={item} />
      ))}
      <ParallaxSection parallaxData={parallax1Banner} height="40vh" />
      {/* <AllTimeFavouritesSection itemsData={bestSeller} />
      <AllTimeFavouritesSection itemsData={bestSeller} />
      <AllTimeFavouritesSection itemsData={bestSeller} /> */}
      {/* <GiftGridSection bannerData={bannerData} isLoading={isLoading} /> */}
      <GiftSwiperSection bannerData={bannerData} isLoading={isLoading} />
      {/* <VideoSection /> */}
      <ServicesSection />
      {/* <GiftingIdeasSection /> */}
      {/* <TestimonialSection testimonialData={websiteTestimonialData} /> */}
      <TestimonialWithParallaxSection
        testimonialData={websiteTestimonialData}
        bannerData={bannerData}
      />
      {/* <ParallaxSection parallaxData={parallax2Banner} height="30vh" /> */}
      <BlogsSection blogData={blogData} />
      <HomeContent />
      <FooterPolicySection />
    </>
  );
}
